/* eslint-disable @typescript-eslint/no-explicit-any */
import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFetchBaseQuery } from "@/redux/apiFetchBaseQuery";

export const twoMFASlice = createApi({
	reducerPath: "twoMFASlice",
	baseQuery: apiFetchBaseQuery,
	tagTypes: ["twofa"],
	endpoints: builder => ({
		createTOTP: builder.mutation<any, { email: string }>({
			query: ({ email }) => ({
				url: `/2fa/totp/create`,
				method: "POST",
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
				},
				body: new URLSearchParams({ email }).toString(),
			}),
			invalidatesTags: ["twofa"],
		}),

		verifyTOTP: builder.mutation<any, { email: string; code: string }>({
			query: ({ email, code }) => ({
				url: `/2fa/totp/verify`,
				method: "POST",
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
				},
				body: new URLSearchParams({ email, code }).toString(),
			}),
			invalidatesTags: ["twofa"],
		}),

		disableTOTP: builder.mutation<any, { email: string }>({
			query: ({ email }) => ({
				url: `/2fa/totp/disable`,
				method: "POST",
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
				},
				body: new URLSearchParams({ email }).toString(),
			}),
			invalidatesTags: ["twofa"],
		}),
	}),
});

export const { useCreateTOTPMutation, useVerifyTOTPMutation, useDisableTOTPMutation } = twoMFASlice;
